import { DEFAULT_NOTIFICATION_DURATION, DEFAULT_NOTIFICATION_POSITION } from '../Notification.constants';
import { useNotificationStore } from '../Notification.store';
import { generateId } from './generateId';
export const addNotification = (notification) => {
    const id = generateId();
    useNotificationStore.getState().addNotification({
        id,
        placement: notification.placement ?? DEFAULT_NOTIFICATION_POSITION,
        ...notification,
    });
    if (notification.autoClose)
        setTimeout(() => useNotificationStore.getState().removeNotification(id), notification.duration ?? DEFAULT_NOTIFICATION_DURATION);
};
